import { notifications } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons-react";
import { rem } from "@mantine/core";

export const useNotification = () => {
  const showNotification = (title, message, type = "loading") => {
    return notifications.show({
      title,
      message,
      loading: type === "loading",
      color: type === "success" ? "teal" : type === "error" ? "red" : undefined,
      icon:
        type === "success" ? (
          <IconCheck style={{ width: rem(18), height: rem(18) }} />
        ) : type === "error" ? (
          <IconX style={{ width: rem(18), height: rem(18) }} />
        ) : undefined,
      autoClose: type === "loading" ? false : 5000,
      withCloseButton: type !== "loading",
    });
  };

  const updateNotification = (id, title, message, type) => {
    notifications.update({
      id,
      title,
      message,
      color: type === "success" ? "teal" : type === "error" ? "red" : undefined,
      icon:
        type === "success" ? (
          <IconCheck style={{ width: rem(18), height: rem(18) }} />
        ) : type === "error" ? (
          <IconX style={{ width: rem(18), height: rem(18) }} />
        ) : undefined,
      loading: false,
      autoClose: 5000,
    });
  };

  return { showNotification, updateNotification };
};
